<template>
  <div class="charttitle-root color-text-primary">
    <div class="maintitle-container">
      <span class="text-h7">{{ title }}</span>
      <span v-if="unit" class="unit text-subtitle-1 color-text-secondary">({{unit}})</span>
    </div>
    <span class="text-subtitle-2 color-text-secondary">{{subtitle}}</span>
  </div>
</template>

<script>
export default {
  name: 'ChartTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/material-dashboard/variables.scss';

.charttitle-root {
  display: flex;
  justify-content: start;
  align-items: baseline;
  gap: 2px;
  flex-direction: column;
  
  .maintitle-container {
    display: flex;
    justify-content: start;
    align-items: baseline;
    gap: 4px;
  }

  p { 
    margin: 0;
  }
  .unit {
    font-weight: 500;
  }
}
</style>